import React from 'react';

import { ButtonGroup, Box, useTheme } from '@mui/material';
import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import CompanyMenu from './CompanyMenu';
import SolutionsMenu from './solutions-menu';
import IndustriesMenu from './IndustriesMenu';
import ResourcesMenu from './ResourcesMenu';
import AppBarMenuButton from './app-bar-menu-button';
import AppBarButton from './AppBarButton';
import PricesMenu from './price-menu';

const AppBarNavigation = ({ ...props }) => {

    const theme = useTheme();
    const navigate = useNavigate();
    const { t } = useTranslation('public');

    return (
        <Box {...props}>
            <ButtonGroup orientation="horizontal" variant="standard">
                <AppBarMenuButton title={t("Company")} vertical='top' horizontal={theme?.direction === 'ltr' ? 'left' : 'right'} >
                    <CompanyMenu />
                </AppBarMenuButton>
                <AppBarMenuButton title={t("solutions.caption")}>
                    <SolutionsMenu />
                </AppBarMenuButton>
                <AppBarButton disableTouchRipple onClick={()=>navigate("/features")} py={0}>
                    {t("features.caption")}
                </AppBarButton>
                <AppBarMenuButton title={t("Industries")} >
                    <IndustriesMenu />
                </AppBarMenuButton>
                <AppBarMenuButton title={t("Pricing")}>
                    <PricesMenu />
                </AppBarMenuButton>
                <AppBarMenuButton title={t("Resources")}>
                    <ResourcesMenu />
                </AppBarMenuButton>
            </ButtonGroup>
        </Box >
    )
}

export default AppBarNavigation;
